export default __webpack_public_path__ + "static/media/first.fb733c4d.gif";